
export const estados = [
    { id: 'Pendiente', displayName: 'Pendiente' },
    { id: 'En curso', displayName: 'En curso' },
    { id: 'Cumplido', displayName: 'Cumplido' },
    { id: 'Incumplido', displayName: 'Incumplido' },
];